module.exports = __webpack_public_path__ + "img/遮盖阴影.35f30ace.png";